import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'web2call';

  ngOnInit(): void {
    // Ensure dark mode is always enabled
    // document.documentElement.classList.add('dark-mode');
  }
}
